module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_6005.91d93a21.png";